import React from "react";
import { aff } from "../mock";

export default function FounderQuote() {
  return (
    <section className="bg-[#FBF8F4] py-20 md:py-28">
      <div className="container-y px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://ybera.us/cdn/shop/files/02sauana.jpg?v=1747687997"
              alt="Sauana Alves"
              className="w-full aspect-[4/5] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 border border-[#C9A961] translate-x-4 translate-y-4 -z-10 hidden md:block" />
          </div>

          <div>
            <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-4">
              Founder
            </p>
            <blockquote className="font-serif-y text-2xl md:text-4xl italic leading-snug text-[#1a1a1a] mb-8">
              &ldquo;I believe every woman deserves to transform her hair, her confidence, and her
              future with the power of beauty in her hands.&rdquo;
            </blockquote>
            <p className="font-sans-y text-[13px] tracking-[0.2em] uppercase text-[#7a7a7a] mb-8">
              Sauana Alves — Co-Founder of Ybera Paris
            </p>
            <a
              href={aff("/pages/our-story")}
              target="_blank"
              rel="noreferrer"
              className="btn-y-outline"
            >
              Our Story
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
